import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs';
import { PaginatedOrderHistory } from '../models/project-summary';
import { PaginatedRequest } from '../models/paginated-request';
import { WorksheetStatusHistory } from '../models/worksheet-status';
import { TaskStatusHistory } from '../models/task-report';


@Injectable()
export class ReportService {

  baseUrl = environment.reportServiceBaserUrl;
  
  constructor(private http: HttpClient) {
  }

  getOrderStatusReport(orderHistoryReportInput, paginatedRequest: PaginatedRequest,reportFilterKey?:string,reportFilterValue?:string){
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    const url = `${this.baseUrl}report/orderStatusReport`;
    let params = new HttpParams()
    .set('page', paginatedRequest.page)
    .set('size', paginatedRequest.pageSize)
    .set('sort', paginatedRequest.sorting);
    if (reportFilterKey) {
      params = params.set(reportFilterKey, reportFilterValue);
    }
    return this.http.post<PaginatedOrderHistory>(url, orderHistoryReportInput, { headers,params });
  }

  downloadOrderStatusReport(orderHistoryReportInput) {
    const headers = new HttpHeaders()
      .set('Accept', 'application/xlsx; charset=utf-8');
    const url = `${this.baseUrl}report/orderStatusReport/export`;
    return this.http.post(url, orderHistoryReportInput, { headers, observe: 'response', responseType: 'blob' });
  }

  getWorksheetStatusReport(wsStatusReportInput, paginatedRequest: PaginatedRequest, reportFilterKey?:string, reportFilterValue?:string) {
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    const url = `${this.baseUrl}report/worksheetStatusReport`;
    let params = new HttpParams()
    .set('page', paginatedRequest.page)
    .set('size', paginatedRequest.pageSize)
    .set('sort', paginatedRequest.sorting);
    if (reportFilterKey) {
      params = params.set(reportFilterKey, reportFilterValue);
    }
    return this.http.post<WorksheetStatusHistory>(url, wsStatusReportInput, { headers,params });
  }

  downloadWorksheetStatusReport(wsStatusReportInput) {
    const headers = new HttpHeaders()
      .set('Accept', 'application/xlsx; charset=utf-8');
    const url = `${this.baseUrl}report/worksheetStatusReport/export`;
    return this.http.post(url, wsStatusReportInput, { headers, observe: 'response', responseType: 'blob' });
  }


  getTaskStatusReport(taskStatusReportInput, paginatedRequest: PaginatedRequest,reportFilterKey?:string,reportFilterValue?:string){
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    const url = `${this.baseUrl}report/taskStatusReport`;
    let params = new HttpParams()
    .set('page', paginatedRequest.page)
    .set('size', paginatedRequest.pageSize)
    .set('sort', paginatedRequest.sorting);
    if (reportFilterValue) {
      params = params.set(reportFilterKey, reportFilterValue);
    }
    return this.http.post<TaskStatusHistory>(url, taskStatusReportInput, { headers,params });
  }

  downloadTaskStatusReport(taskStatusReportInput) {
    const headers = new HttpHeaders()
      .set('Accept', 'application/xlsx; charset=utf-8');
    const url = `${this.baseUrl}report/taskStatusReport/export`;
    return this.http.post(url, taskStatusReportInput, { headers, observe: 'response', responseType: 'blob' });
  }

}


// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/services/report.services.ts